import { PublicKey } from '@solana/web3.js'
import { lazyDistributorKey } from '@helium/lazy-distributor-sdk'
import { HNT_MINT, IOT_MINT, MOBILE_MINT } from '@helium/spl-utils'

export const PROGRAM_ID = new PublicKey(
  'GYjdhK3SQK5LTi5TnBDBZZyzbdw4BAYpyNhoHfap9ysP',
)

export const STAKE_MINT = new PublicKey(
  '5WDwC9a4Mj18d8LpAX8cypQMzWfvMdNmmvfs35FFVTwo',
)

export const COLLECTION_AUTHORITY = new PublicKey(
  'EHhcXxjmNpvKxfxitSwqU1g1SyCYxXUpVLVEfkvD56hV',
)

export const TREASURY_WALLET_ADDRESS_SOL = new PublicKey(
  '5H3k8cjdR5vGSzy1mxYGyx4BThxbEe5ETAZx7NYPAw78',
)

export const TREASURY_WALLET_ADDRESS =
  '14s1pLdZ3Z8EobTURy7Jn1hBdJDdNyjYZhNvrssNXbBRPZ2PaHn'

export const Mints: Record<string, string> = {
  IOT: IOT_MINT.toBase58(),
  MOBILE: MOBILE_MINT.toBase58(),
  HNT: HNT_MINT.toBase58(),
}

export const MOBILE_LAZY_KEY = lazyDistributorKey(
  new PublicKey(Mints.MOBILE),
)[0]

export const IOT_LAZY_KEY = lazyDistributorKey(new PublicKey(Mints.IOT))[0]

export const HNT_LAZY_KEY = lazyDistributorKey(new PublicKey(Mints.HNT))[0]

export const ORGANIZATION = process.env.NEXT_PUBLIC_ORGANIZATION_ADDRESS

export const NFT_VOTER = process.env.NEXT_PUBLIC_NFT_VOTER

export const PROPOSAL_CONFIG = process.env.NEXT_PUBLIC_PROPOSAL_CONFIG

export const STATE_CONTROLLER = process.env.NEXT_PUBLIC_STATE_CONTROLLER

export const AUCTION_HOUSE = process.env.NEXT_PUBLIC_AUCTION_HOUSE

export const DEWICATS_COLLECTION = new PublicKey(
  process.env.NEXT_PUBLIC_COLLECTION_MINT,
)
